export enum PolarPattern {
	Cardioid = 'cardioid',
	Supercardioid = 'supercardioid',
	Bidirectional = 'bidirectional',
	Omnidirectional = 'omnidirectional',
	Toroid = 'toroid',
	Hypercardioid = 'hypercardioid'
}
